import React from 'react';
import { Container, Box, Typography, IconButton } from '@mui/material';
import { Link } from 'react-router-dom';
import InstagramIcon from '@mui/icons-material/Instagram';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import LoginIcon from '@mui/icons-material/Login';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import ROUTES from '../common/Routing/Routes';
import { useAuth } from '../common/Auth/AuthProvider';
import './Footer.css';

const Footer = () => {
  const { isAuthenticated } = useAuth();

  return (
    <footer className="footer">
      <Container maxWidth="lg">
        <Box className="footer-container">
          <div className="footer-brand">
            <Typography variant="h6">Readerly</Typography>
            <Typography variant="body2">Оренда книжок за донат. Усі гроші — на дрони для ЗСУ.</Typography>
            <Typography variant="body2">Івано-Франківськ</Typography>
          </div>

          <nav className="footer-column" aria-label="Навігація">
            <Typography variant="subtitle2">Сторінки</Typography>
            <Link to={ROUTES.HOME}>Книги</Link>
            <Link to={ROUTES.TOP}>Топи</Link>
            <Link to={ROUTES.SHOP}>Крамничка</Link>
            <Link to={ROUTES.FAQ}>Як це працює</Link>
            <Link to={ROUTES.ABOUT}>Про нас</Link>
          </nav>

          <div className="footer-column">
            <Typography variant="subtitle2">Контакти</Typography>
            <div className="footer-social">
              <IconButton
                component="a"
                href="https://www.instagram.com/readerly_com/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-icon"
                aria-label="Instagram Readerly"
              >
                <InstagramIcon />
              </IconButton>
              <IconButton
                component="a"
                href="https://www.threads.net/@readerly_com"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-icon"
                aria-label="Threads Readerly"
              >
                <AlternateEmailIcon />
              </IconButton>
            </div>
          </div>

          <div className="footer-column footer-quick">
            <Typography variant="subtitle2">Швидко</Typography>
            {isAuthenticated ? (
              <>
                <Link to={ROUTES.WISH_LIST}>
                  <FavoriteBorderIcon fontSize="small" /> Вішліст
                </Link>
                <Link to={ROUTES.PROFILE}>
                  <AccountCircleOutlinedIcon fontSize="small" /> Профіль
                </Link>
              </>
            ) : (
              <>
                <Link to={ROUTES.LOGIN}>
                  <LoginIcon fontSize="small" /> Логін
                </Link>
                <Link to={ROUTES.REGISTER}>
                  <AppRegistrationIcon fontSize="small" /> Реєстрація
                </Link>
              </>
            )}
          </div>
        </Box>

        <Typography className="footer-copy" variant="body2">
          © 2026 Readerly. Усі права захищені.
        </Typography>
      </Container>
    </footer>
  );
};

export default Footer;
